import React from 'react';
import { Box, Grid, TableCell, Container, TableBody, FormHelperText, TableHead, ButtonGroup, TableContainer, Table, TableRow, Select, MenuItem, ListItemText, FormControl, InputLabel, Checkbox, Button, Menu, CircularProgress } from '@mui/material';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import * as XLSX from 'xlsx';


import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';



export class AffinityMis extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedYear: [],
            selectedMonth: [],
            userSource: [],
            years: Array.from(Array(new Date().getFullYear() - 2021), (_, i) => (i + 2022)),
            months: [{ name: "January", value: 1 }, { name: "February", value: 2 }, { name: "March", value: 3 }, { name: "April", value: 4 }, { name: "May", value: 5 }, { name: "June", value: 6 }, { name: "July", value: 7 }, { name: "August", value: 8 }, { name: "September", value: 9 }, { name: "October", value: 10 }, { name: "November", value: 11 }, { name: "December", value: 12 }],
            packageId: { '4024': '6Mbrs', '4025': '4Mbrs' },
            dateKeys: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"],
            monthKeys: ["April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March"],
            tvsHrData: [],
            tvsHrDataDateWise: [],
            tvsHrDataMonthWise: [],
            exportType: 'xlsx',
            renderingTvsHrData: [],
            loading: {},
            anchorEl: null,
            server: {},
            activeTable: 0,
            downLoadloading: false,
            showSnack: false,
            snackMsg: '',
            snackType: 'info',
            userSourceAmountKeys: [],
            tvsHrDataJson: {},
            tvsHrDataMISDownloadUrl : ''
        }
    }

    downloadXlsx(Data) {

        let fileName = `${Date.now()}.xlsx`;

        let downloadData = [];
        for (let i in Data) {
            downloadData.push({ state: i, ...Data[i] })
        }

        const ws = XLSX.utils.table_to_sheet(document.getElementById("total_mis_month_year_table"));
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'xlsx' });
        const url = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        link.click();
        link.remove();
    }



    handleChange(type, value) {
        let selectedyear;
        let selectedmonth;

        switch (type) {
            case 'years':
                selectedyear = value
                this.setState({ selectedYear: selectedyear })
                break
            case 'months':
                selectedmonth = value
                this.setState({ selectedMonth: selectedmonth })
                break

        }
    }


    downloadFile(url) {
        var link = document.createElement("a");
        link.setAttribute('download', '');
        link.href = url;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    exportFile(filetype) {
        let payload = {
            fileType: filetype
          }
          if(this.state.tvsHrDataMISDownloadUrl == "")
          this.downloadHrTvsData(payload)
          else
          this.downloadFile(this.state.tvsHrDataMISDownloadUrl)
        
    }


    downloadHrTvsData(payload) {

        this.setState({
            downLoadloading: true
        })
        _axios.post('affinity/downloadHrTvsCredit', {
            "service": 1,
            ...payload
        }, {
            ignoreLoading: true,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.data && response.data.isSuccess && response.data.preSignedUrl) {
                this.downloadFile(response.data.preSignedUrl)
                this.setState({
                    downLoadloading: false,
                    showSnack: true,
                    snackMsg: 'File downloaded successfully!',
                    snackType: 'success',
                    tvsHrDataMISDownloadUrl:response.data.preSignedUrl,
                })

            } else if (response.data && !response.data.isSuccess) {
                this.setState({
                    downLoadloading: false,
                    showSnack: true,
                    snackMsg: 'File downloaded failed!',
                    snackType: 'error',
                    tvsHrDataMISDownloadUrl:'',
                })
            }
        }).catch((error) => {
            this.setState({
                downLoadloading: false,
                showSnack: true,
                snackMsg: 'File downloaded failed!',
                snackType: 'error',
            })
        })
    }

    componentDidMount() {
        this.fetchHrTvs();
        this.ChangeDataFormatForUI()
        this.ChangeDataFormatForUIDate()
        this.ChangeDataFormatForMonth()
    }


    fetchDistinctStates() {
        let data = this.state.tvsHrData;
        let states = [];
        data.forEach((arr) => {

            if (!arr.state)
                arr.state = 'N/A'

            if (!states.includes(arr.state))
                states.push(arr.state)
        })
        this.setState({ states: states })
    }

    fetchDistinctUserSource() {
        let data = this.state.tvsHrData;
        let userSource = [];
        data.forEach((arr) => {

            if (!arr.usersource)
                arr.usersource = 'N/A'

            if (!userSource.includes(arr.usersource))
                userSource.push(arr.usersource)

        })
        this.setState({ userSource: userSource })
    }


    fetchDistinctYear() {
        let data = this.state.tvsHrData;
        let years = [];
        data.forEach((arr) => {
            if (!years.includes(arr.year))
                years.push(arr.year)
        })
        this.setState({ years: years })
    }




    fetchHrTvs(obj = {}) {
        this.setLoadingServer("hrTvs", true, true);
        let payLoad = {};
        payLoad['service'] = 1;
        Object.keys(obj).map((item) => {
            payLoad[item] = obj[item];
        });
        _axios.post('affinity/hrTvsCredit', payLoad, {
            ignoreLoading: true,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                if (response.data && response) {
                    this.setLoadingServer("hrTvs", false, true);
                    this.setState({
                        tvsHrData: response.data.result1,
                        tvsHrDataDateWise: response.data.result2,
                        tvsHrDataMonthWise: response.data.result3
                    });

                    this.fetchDistinctStates();
                    this.fetchDistinctUserSource();
                    this.generateTableHeaders();
                    this.ChangeDataFormatForUI()
                    this.ChangeDataFormatForUIDate();
                    this.ChangeDataFormatForMonth();
                }
            }).catch((error) => {
                this.setLoadingServer("hrTvs", false, false);

            })
    }


    setLoadingServer(name, loading, server) {
        this.setState((prev) => ({
            loading: {
                ...prev.loading,
                [name]: loading
            },
            server: {
                ...prev.server,
                [name]: server
            }
        }))
    }

    handleClose = async (item) => {
        this.setState({ anchorEl: null });
        if (item) {
            this.setState({ exportType: item.title });
        }
    };

    filterData = async (event) => {
        let payLoad = {};
        if(this.state.selectedMonth.length ==0 ^ this.state.selectedYear.length == 0){
            console.log(this.state.selectedMonth.length ==0 ^ this.state.selectedYear.length == 0)
        return;
        }

        if(this.state.selectedMonth.length != 0){
            payLoad["month"] = this.state.selectedMonth;
            payLoad["year"]= this.state.selectedYear;
        }
        this.setLoadingServer("hrTvs", true, true);
        payLoad['service'] = 1;

        _axios.post('affinity/hrTvsCredit', { ...payLoad}, {
            ignoreLoading: true,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                if (response.data && response) {
                    this.setLoadingServer("hrTvs", false, true);
                    this.setState({
                        tvsHrData: response.data.result1,
                        tvsHrDataDateWise: response.data.result2,
                        tvsHrDataMonthWise: response.data.result3
                    });

                    this.fetchDistinctStates();
                    this.fetchDistinctUserSource();
                    this.ChangeDataFormatForUI()
                    this.ChangeDataFormatForUIDate();
                    this.ChangeDataFormatForMonth();
                }
            }).catch((error) => {
                this.setLoadingServer("hrTvs", false, false);

            })

    };

    generateTableHeaders() {
        let key = [];
        let packageAmount = Object.values(this.state.packageId);
        let userSource = this.state.userSource;

        userSource.forEach(source => {
            packageAmount.forEach(amount => {
                key.push(source + " " + amount)
            })
            key.push(source+ " Total")
        })

        this.setState({ userSourceAmountKeys: key })
    }


    ChangeDataFormatForUI() {

        let JSONData = {'N/A' : {}};
        let data = this.state.tvsHrData;
        data.forEach(element => {
            if (!JSONData.hasOwnProperty(element["state"]))
                JSONData[element["state"]] = {};
            JSONData[element["state"]][element["usersource"] + " " + this.state.packageId[element["packageid"]]] = element["total_count"]
            if(!JSONData[element["state"]].hasOwnProperty(element["usersource"] + " Total"))
            JSONData[element["state"]][element["usersource"] + " Total"] = 0
            JSONData[element["state"]][element["usersource"] + " Total"] += parseInt(element["total_count"]);
        })

        let NADate = JSONData['N/A'];
        delete JSONData['N/A']
        JSONData['N/A'] = NADate;

        this.setState({ tvsHrDataJson: JSONData })
    }

    ChangeDataFormatForUIDate() {
        let JSONData = { "count": {} };
        let data = this.state.tvsHrDataDateWise;
        data.forEach(element => {
            if (!JSONData.hasOwnProperty(element["usersource"]))
                JSONData[element["usersource"]] = {};
            let key = new Date(element["dated"]).toLocaleDateString('en-GB').split('/')[0]
            JSONData[element["usersource"]][key] = element["packages_count"]

            if (!JSONData["count"].hasOwnProperty(key))
                JSONData["count"][key] = 0;

            JSONData["count"][key] += element["packages_count"]



        })

        let count = JSONData["count"];
        delete JSONData["count"];
        JSONData["Total"] = count;

        // if(usersource=="count")


        this.setState({ tvsHrDataDateWise: JSONData })
    }

    ChangeDataFormatForMonth() {
        let JSONData = { "count": {} };
        let data = this.state.tvsHrDataMonthWise;
        data.forEach(element => {
            if (!JSONData.hasOwnProperty(element["usersource"]))
                JSONData[element["usersource"]] = {};

            if (element["month"] > 3) {
                if (!JSONData["count"].hasOwnProperty(element["month"] - 4))
                    JSONData["count"][element["month"] - 4] = 0;

                JSONData[element["usersource"]][element["month"] - 4] = element["packages_count"];
                JSONData["count"][element["month"] - 4] += element["packages_count"];
            }
            else {
                if (!JSONData["count"].hasOwnProperty(element["month"] + 8))
                    JSONData["count"][element["month"] + 8] = 0;
                JSONData[element["usersource"]][element["month"] + 8] = element["packages_count"]
                JSONData["count"][element["month"] + 8] += element["packages_count"];

            }
        })

        let count = JSONData["count"];
        delete JSONData["count"];
        JSONData["Total"] = count;


        this.setState({ tvsHrDataMonthWise: JSONData })
    }


    render() {
        const fileList = [
            {
                id: 'CSV',
                title: 'csv'
            },
            {
                id: 'XLSX',
                title: 'xlsx'
            }
        ];
        const open = Boolean(this.state.anchorEl);
        return (
            this.state.loading["hrTvs"] || this.state.downLoadloading ? <Box sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',

            }}><CircularProgress sx={{ margin: 'auto' }} /></Box> :

                <Box sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    pˀy: 2
                }}>
                    <Container maxWidth={false}>
                        <TableContainer>
                            <Grid>

                                <FormControl sx={{ width: '140px', margin: '10px', minWidth: 120 }} size='small' variant="outlined">
                                    <InputLabel>Month</InputLabel>
                                    <Select
                                        required
                                        multiple
                                        value={this.state.selectedMonth}
                                        onChange={(ev) => { this.handleChange('months', ev.target.value) }}
                                        renderValue={(selected) => ""}
                                    >
                                        {this.state.months.map((val, idx) => (
                                            <MenuItem
                                                sx={{ py: 0 }}
                                                value={val.value}
                                                key={idx}
                                                name={val.name}
                                            >
                                                <Checkbox checked={this.state.selectedMonth.includes(val.value)}
                                                    color="primary"
                                                    size="small" />
                                                <ListItemText primary={val.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl sx={{ width: '140px', margin: '10px', minWidth: 120 }} size='small' variant="outlined">
                                    <InputLabel>Year</InputLabel>
                                    <Select
                                        required
                                        multiple
                                        value={this.state.selectedYear}
                                        onChange={(ev) => { this.handleChange('years', ev.target.value) }}
                                        renderValue={(selected) => selected.join(', ')}
                                    >
                                        {this.state.years.map((val, idx) => (
                                            <MenuItem
                                                sx={{ py: 0 }}
                                                value={val}
                                                key={idx}
                                                name={val}
                                            >
                                                <Checkbox checked={this.state.selectedYear.includes(val)}
                                                    color="primary"
                                                    size="small" />
                                                <ListItemText primary={val} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl sx = {{margin: '10px'}}>
                                    <Button
                                        sx={{ px: 2 }}
                                        onClick={() => this.filterData()}
                                        startIcon={<FilterAltIcon size="18"/>} 
                                        variant="outlined"
                                        disabled = {this.state.selectedMonth.length == 0 ^ this.state.selectedYear.length == 0}
                                        >
                                       Submit
                                    </Button>

                                </FormControl>

                                <ButtonGroup sx={{ marginTop: "10px" , float : 'right'}}>
                                    <Button
                                        sx={{ px: 2 }}
                                        onClick={() => this.exportFile(this.state.exportType)}
                                        startIcon={<ExportIcon size="18" />}
                                    >
                                        Customer Data
                                    </Button>
                                    <Button
                                        onClick={(e) =>
                                            this.setState({ anchorEl: e.currentTarget })
                                        }
                                        endIcon={<ArrowDropDownIcon />}
                                    >
                                        {this.state.exportType}
                                    </Button>
                                </ButtonGroup>

                                <FormControl>
                                    <FormHelperText sx={{ color: 'red', marginTop: "10px" }}>NOTE : Please select both Month and Year .  Data Shown is From October 2022</FormHelperText>
                                </FormControl>


                                <Menu
                                    id="export-menu"
                                    open={open}
                                    anchorEl={this.state.anchorEl}
                                    onClose={() => this.handleClose()}
                                    MenuListProps={{
                                        'aria-labelledby': 'exporttypeMenu'
                                    }}
                                >
                                    {fileList.map((menu) => (
                                        <MenuItem
                                            key={menu.id}
                                            onClick={() => this.handleClose(menu)}
                                        >
                                            {menu.title}
                                        </MenuItem>
                                    ))}
                                </Menu>

                            </Grid>

                            <Grid item xs={12} sm={2}>
                            </Grid>
                            <Table id='total_mis_month_year_table' sx={{ width: "auto" }}>
                                <TableHead>

                                    <TableRow>
                                        <TableCell>
                                            State
                                        </TableCell>
                                        {this.state.userSourceAmountKeys.map(element =>
                                            (<TableCell>{element}</TableCell>))

                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {

                                        Object.keys(this.state.tvsHrDataJson).map((stateName, index) => (
                                            <TableRow>
                                                <TableCell>{stateName}</TableCell>
                                                {this.state.userSourceAmountKeys.map(element =>
                                                    (<TableCell>{this.state.tvsHrDataJson[stateName][element] ? this.state.tvsHrDataJson[stateName][element] : 0}</TableCell>))}
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>


                        </TableContainer>


                        <TableContainer sx={{ marginTop: "100px" }}>

                            <h3 style={{ padding: '7px' }}>MONTH TILL DATE</h3>
                            <Table sx={{ width: "200px" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            Source
                                        </TableCell>
                                        {this.state.dateKeys.map(element =>
                                            (<TableCell>{element}</TableCell>))

                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {

                                        Object.keys(this.state.tvsHrDataDateWise).map((userSource, index) => (
                                            <TableRow >
                                             
                                                <TableCell sx = {userSource == "Total" ? {fontWeight:"500!important"}: {}} >{userSource}</TableCell>
                                                {this.state.dateKeys.map(element =>
                                                    (<TableCell sx = {userSource == "Total" ? {fontWeight:"500!important"}: {}} >{this.state.tvsHrDataDateWise[userSource][element] ? this.state.tvsHrDataDateWise[userSource][element] : 0}</TableCell>))}
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TableContainer sx={{ marginTop: "100px" }}>

                            <h3 style={{ padding: '7px' }}>YEAR TILL DATE</h3>

                            <Table sx={{ width: "200px" }}>
                                <TableHead>

                                    <TableRow>
                                        <TableCell>
                                            Source
                                        </TableCell>
                                        {this.state.monthKeys.map(element =>
                                            (<TableCell>{element}</TableCell>))

                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {

                                        Object.keys(this.state.tvsHrDataMonthWise).map((userSource, index) => (
                                            <TableRow>

                                                <TableCell sx = {userSource == "Total" ? {fontWeight:"500!important"}: {}}>{userSource == "null" ? "standAlone" : userSource}</TableCell>
                                                {Object.keys(this.state.months).map(element =>

                                                (

                                                    <TableCell sx = {userSource == "Total" ? {fontWeight:"500!important"}: {}}>{this.state.tvsHrDataMonthWise[userSource][element] ? this.state.tvsHrDataMonthWise[userSource][element] : 0}</TableCell>))}
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>

                        </TableContainer>


                    </Container>
                </Box>
        )
    }



}